import { gql } from "graphql-tag";

const getRolesByInstitution = gql`
  query GetRolesByInstitution($institutionId: String!) {
    rolesByInstitution(institution_id: $institutionId) {
      email
      id
      last_name
      last_name2
      name
      role_name
    }
  }
`;

export { getRolesByInstitution }